import React from 'react'
import Icon from './Icon.png'

function Header() {
    return (
        <header>
            <img src={Icon} alt="" />
            <h1><span>RANDOM </span>IMAGES Gallery</h1>
        </header>
    )
}

export default Header
